<script lang="ts" setup>
import constants from '~/constants'

const props = withDefaults(
  defineProps<{
    buttonTitle?: string | null
    buttonTitles?: string[]
    iconName?: string | null
    isWhite?: boolean
    needToAgreeWithDataProtectionPolicy?: boolean
    needToAgreeWithOfferForSuppliers?: boolean
  }>(),
  {
    buttonTitle: null,
    buttonTitles: () => [],
    iconName: null,
    isWhite: false,
    needToAgreeWithDataProtectionPolicy: false,
    needToAgreeWithOfferForSuppliers: false
  }
)
</script>

<template>
  <div class="agreement" :class="{ 'agreement_white': isWhite, 'text-white': isWhite }">
    Нажимая кнопку <template v-if="buttonTitle">
      <span>«{{ buttonTitle }}»</span>
    </template><template v-else-if="buttonTitles.length">
      <span>«{{ buttonTitles.join('» или «') }}»</span>
    </template><template v-else-if="iconName">
      <span class="whitespace-nowrap">«<SvgIcon :name="iconName" />»</span>
    </template>,
    <template v-if="needToAgreeWithDataProtectionPolicy">
      я&nbsp;принимаю условия <a :href="constants.documentUrls.consultationUserAgreement" target="_blank">пользовательского соглашения</a> и&nbsp;даю своё <a :href="constants.documentUrls.dataProtectionPolicy" target="_blank">согласие на&nbsp;обработку персональных данных</a>.
    </template>
    <template v-else-if="needToAgreeWithOfferForSuppliers">
      я&nbsp;принимаю условия <a :href="constants.documentUrls.offerForSuppliers" target="_blank">оферты для поставщиков</a> и&nbsp;даю своё <a :href="constants.documentUrls.dataProtectionPolicy" target="_blank">согласие на&nbsp;обработку персональных данных</a>.
    </template>
    <template v-else>
      я&nbsp;принимаю условия <a :href="constants.documentUrls.userAgreement" target="_blank">пользовательского соглашения</a>.
    </template>
  </div>
</template>

<style lang="scss" scoped>
.agreement {
  font-size: 14px;
  line-height: 18px;

  &_white > a {
    color: white;
    text-decoration: underline;
  }
}
</style>
